import { DomElement } from "spyne";

export class SidebarMenuContainerEl extends DomElement {
  constructor(props = {}) {
    props.class = "sidebar-menu-container";
    props.data.__cms__isProxy = true;

    props.template = require("./templates/sidebar-menu-quick-start-container.tmpl.html");

    super(props);
  }
}
